import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.2 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-1">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionLabel = ({ children, light = false }) => (
  <p
    className={`text-xs tracking-[0.3em] uppercase font-semibold ${
      light ? "text-gold-light" : "text-gold"
    }`}
  >
    {children}
  </p>
);

export const PageHeader = ({ label, lines, sub }) => (
  <header className="bg-ink text-cream pt-40 pb-24 px-6 sm:px-12 lg:px-24 relative overflow-hidden">
    <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
      style={{ backgroundImage: "linear-gradient(#faf9f6 1px, transparent 1px), linear-gradient(90deg, #faf9f6 1px, transparent 1px)", backgroundSize: "80px 80px" }} />
    <div className="max-w-7xl mx-auto relative">
      <Reveal y={16}>
        <SectionLabel light>{label}</SectionLabel>
      </Reveal>
      <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
        <MaskedLines lines={lines} delay={0.3} />
      </h1>
      {sub && (
        <Reveal delay={0.6}>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed font-medium text-white">{sub}</p>
        </Reveal>
      )}
    </div>
  </header>
);
